import CustomerData from "./customerData";
import ProductPage from "./productPage";
import AddToWishlist from "./addToWishlist";
import MainPage from "./mainPage";
import StatusCart from "./statusCart";
import CategoryPage from "./categoryPage";
import PurchasedItems from "./purchasedItems";
import NotFound from "./notFound";
import addContacts from "./addContacts";

export default { CustomerData, ProductPage, AddToWishlist, MainPage, StatusCart, CategoryPage, PurchasedItems, NotFound, addContacts };
